import archeryGame from "./archeryGame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class archeryArrow extends cc.Component {

    moveSpeed:number = 2000;

    archeryGame:archeryGame = null;

    bindGame(archeryGame:archeryGame){
        this.archeryGame = archeryGame;
    }

    startMove(){
        let targetY:number = 1000;
        let distance:number = Math.abs(targetY - this.node.y);
        let needTime = distance / this.moveSpeed;
        cc.tween(this.node).to(needTime,{y:targetY}).delay(1).call(()=>{
            this.node.destroy();
        }).start();
    }

    onCollisionEnter(otherCollider, selfCollider) {
        this.archeryGame.coilderOneNode(otherCollider.tag,otherCollider.node);
    }

}
